module.exports = __webpack_public_path__ + "img/icon_is_get.528cf6ee.png";